import { defineNuxtMiddleware } from '@nuxtjs/composition-api'

export default defineNuxtMiddleware(ctx => {
  if (ctx.$auth.loggedIn) {
    ctx.redirect('/')
  }
})
